import { call, put, select, delay, take, race } from 'redux-saga/effects';
import { LOGOUT_REQUEST } from '../../logout/action';
import { SYSTEM_SUSPEND } from '../../systemSuspend/action';
import { refreshTokenAction } from '../refreshAccessToken/action';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* startTokenRefreshTimerSaga() {
    const userCredential = yield select(selectUserCredentials)
    const { expirationTime } = userCredential;
    const timeNow = Date.now();
    const timeToRefresh = expirationTime - timeNow - (10 * 60 * 1000); // 10 minutes before expiration
    if (timeToRefresh > 0) {
      // Wait until 10 minutes before expiration or until LOGOUT_REQUEST happens
      const { timedOut, logout, suspend  } = yield race({
        timedOut: delay(timeToRefresh),
        logout: take(LOGOUT_REQUEST),
        suspend: take(SYSTEM_SUSPEND) 
      });
  
      if (logout || suspend) {
        // Logout or suspend occurred, exit the saga
        return;
      }
    }
    // Dispatch refresh token action before it expires
    yield put(refreshTokenAction());
  }